import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { TaskListItem } from 'src/models/taskList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { TaskListCallbackStoreContract } from '../interfaces';

export class GetTheOpenTaskModuleTasksForTheUserCallBack extends Callback<TaskListItem[]> {
	public constructor(
		private readonly store: TaskListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: TaskListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.OPEN, this.queryIdentifier)) {
			return;
		}

		this.store.setOpenTaskList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
